import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import type { MapLocation } from "./mapData";
import "./WorldMap.css";

interface Props {
  location: MapLocation;
  onClose: () => void;
}

export function LocationModal({ location, onClose }: Props) {
  const navigate = useNavigate();

  // Close on Escape
  useEffect(() => {
    function handleKey(e: KeyboardEvent) {
      if (e.key === "Escape") onClose();
    }
    window.addEventListener("keydown", handleKey);
    return () => window.removeEventListener("keydown", handleKey);
  }, [onClose]);

  return (
    <div
      className="location-modal__overlay"
      onClick={(e) => e.target === e.currentTarget && onClose()}
      role="dialog"
      aria-modal="true"
      aria-label={`${location.name} – brett`}
    >
      <div className="location-modal">
        <div className="location-modal__header">
          <h2 className="location-modal__title">{location.name}</h2>
          <p className="location-modal__theme">{location.theme}</p>
          <button
            className="location-modal__close"
            onClick={onClose}
            aria-label="Lukk"
          >
            ✕
          </button>
        </div>

        <div className="location-modal__levels">
          <p className="location-modal__levels-heading">Brett</p>

          {location.levels.map((level, index) => (
            <button
              key={level.id}
              className="level-card"
              onClick={() => {
                onClose();
                navigate(`/level/${level.id}`);
              }}
            >
              <div className="level-card__number">{index + 1}</div>

              <div className="level-card__info">
                <div className="level-card__name">{level.name}</div>
                <div className="level-card__meta">{level.wordCount} ord</div>
              </div>

              <Stars count={0} />

              <span className="level-card__arrow">›</span>
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}

function Stars({ count }: { count: 0 | 1 | 2 | 3 }) {
  return (
    <div className="level-card__stars" aria-label={`${count} av 3 stjerner`}>
      {[1, 2, 3].map((n) => (
        <span
          key={n}
          className={`level-card__star${n <= count ? " level-card__star--filled" : ""}`}
        >
          ★
        </span>
      ))}
    </div>
  );
}
